import { Directive, HostListener, Input } from '@angular/core';
@Directive({
    selector: '[specialIsAlphaNumeric]',

})
export class SpecialCharacterDirective {

  regexStr = /[~!*$?_~{}#<>|*;^¬¦]/;

  @Input() isAlphaNumeric: boolean;

  constructor() { }


  @HostListener('keypress', ['$event']) onKeyPress(event) {
    return !new RegExp(this.regexStr).test(event.key);
  }

  @HostListener('paste', ['$event']) blockPaste(event: KeyboardEvent) {
    this.validateFields(event);
  }

  validateFields(event) {
    setTimeout(() => {

      // this.el.nativeElement.value = this.el.nativeElement.value.replace( /^[a-zA-Z0-9 ]+$/, '');
      event.preventDefault();

    }, 100)
  }

}